import { render, staticRenderFns } from "./ProjectionFundamental.vue?vue&type=template&id=b49ba12e&"
import script from "./ProjectionFundamental.vue?vue&type=script&lang=ts&"
export * from "./ProjectionFundamental.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectionFundamental.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports